"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.MapButtonsWrapper = exports.MapButtons = exports.MapButton = exports.IconWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Typography_1 = require("../../atoms/Typography");
const MapButtonsWrapper = styled_components_1.default.div `
  position: absolute;
  top: 10rem;
  z-index: 4;
  @media ${media_1.media.desktop} {
    left: 0;
    top: 8rem;
  }

  @media ${media_1.media.mediumDesktop} {
    top: 10rem;
  }
`;
exports.MapButtonsWrapper = MapButtonsWrapper;
const MapButtons = styled_components_1.default.div `
  display: flex;
  padding: 0rem 0rem 0rem 2rem;
`;
exports.MapButtons = MapButtons;
const MapButton = styled_components_1.default.button `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors_1.white};
  border-radius: 10px;
  padding: 0.6rem 1.6rem;
  box-sizing: border-box;
  border: 2px solid ${(props) => (props.$isActive ? colors_1.blue : "transparent")};
  margin-right: 1rem;
  cursor: pointer;
  ${(props) => props.$isDisabled &&
    `opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;`}
`;
exports.MapButton = MapButton;
const Title = (0, styled_components_1.default)(Typography_1.H4) `
  color: ${(props) => (props.$isActive ? colors_1.acBlueDark : colors_1.gray300)};
  margin-right: 0.8rem;
`;
exports.Title = Title;
const IconWrapper = styled_components_1.default.div `
  background-color: ${(props) => (props.$isActive ? colors_1.acBlueDark : colors_1.gray300)};
  mask: url(${(props) => props.$src});
  mask-size: 100% 100%;
  width: 1.4rem;
  height: 1.4rem;
`;
exports.IconWrapper = IconWrapper;
